export default {
  miao: 'Miếu',
  wang: 'Vượng',
  de: 'Đắc',
  li: 'Lợi',
  ping: 'Bình',
  bu: 'Bất',
  xian: 'Hãm',
} as const;
